import { Zap } from "lucide-react";

export const Footer = () => {
  return (
    <footer className="relative border-t border-white/10 bg-[#020202] pt-20 pb-10 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 sm:px-10">
        <div className="grid lg:grid-cols-12 gap-12 pb-16">
          <div className="lg:col-span-6">
            <div className="flex items-center gap-3 mb-6">
              <span className="inline-flex items-center justify-center w-10 h-10 bg-lime-400 text-black">
                <Zap className="w-5 h-5" strokeWidth={2.5} fill="currentColor" />
              </span>
              <span className="font-display text-3xl font-black tracking-tight">
                <span className="text-lime-400">ZO</span>
                <span className="text-white">O</span>
                <span className="text-lime-400">MY</span>
              </span>
            </div>
            <p className="max-w-md text-slate-400 text-sm leading-relaxed">
              India&apos;s sharpest electric two-wheeler rental & dealership network.
              किफायते पे EV बाईक्स उपलब्ध.
            </p>
          </div>

          <div className="lg:col-span-3">
            <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-slate-500 mb-4">
              Reach
            </div>
            <ul className="space-y-2 text-slate-300 text-sm">
              <li><a href="tel:9217470162" data-testid="footer-phone-link-1" className="hover:text-lime-400 transition-colors">+91 92174 70162</a></li>
              <li><a href="tel:9217476487" data-testid="footer-phone-link-2" className="hover:text-lime-400 transition-colors">+91 92174 76487</a></li>
              <li><a href="mailto:zoomy.now@gmail.com" data-testid="footer-email-link" className="hover:text-lime-400 transition-colors">zoomy.now@gmail.com</a></li>
            </ul>
          </div>

          <div className="lg:col-span-3">
            <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-slate-500 mb-4">
              Explore
            </div>
            <ul className="space-y-2 text-slate-300 text-sm">
              <li><a href="#fleet" className="hover:text-lime-400 transition-colors">Fleet</a></li>
              <li><a href="#stats" className="hover:text-lime-400 transition-colors">Numbers</a></li>
              <li><a href="#partner" className="hover:text-lime-400 transition-colors">Partner with us</a></li>
              <li><a href="#contact" className="hover:text-lime-400 transition-colors">Contact</a></li>
            </ul>
          </div>
        </div>

        {/* Giant brand mark */}
        <div className="relative border-t border-white/10 pt-12 pb-8">
          <div
            aria-hidden
            className="font-display font-black tracking-tighter text-[20vw] sm:text-[18vw] leading-none text-transparent select-none whitespace-nowrap"
            style={{
              WebkitTextStroke: "1px rgba(163,230,53,0.18)",
            }}
          >
            ZOOMY⚡
          </div>
        </div>

        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 pt-8 border-t border-white/10">
          <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-slate-500">
            © {new Date().getFullYear()} Zoomy Electric Mobility · All rights reserved
          </div>
          <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-slate-500">
            Built for riders. Engineered for partners.
          </div>
        </div>
      </div>
    </footer>
  );
};
